var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam", attrs: { id: "train" } },
    [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "exam-con" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._l(_vm.groupRecordList, function(l, QIndex) {
                return [
                  _c(
                    "div",
                    { staticClass: "type" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.getNum(QIndex)) +
                              "、" +
                              _vm._s(l.title) +
                              "（共" +
                              _vm._s(l.questionRecordFullList.length) +
                              "题，每题" +
                              _vm._s(l.eachScore) +
                              "分）"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(l.questionRecordFullList, function(q, index) {
                        return _c("div", { staticClass: "list" }, [
                          q.answerRecord
                            ? _c(
                                "div",
                                { attrs: { title: q.num } },
                                [
                                  _c("p", [
                                    q.answerRecord.answerState == "Right"
                                      ? _c("span", { staticClass: "right" }, [
                                          _vm._v("【正确】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    q.answerRecord.answerState == "Wrong"
                                      ? _c("span", { staticClass: "wrong" }, [
                                          _vm._v("【错误】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    q.answerRecord.answerState == "HalfRight"
                                      ? _c("span", { staticClass: "right" }, [
                                          _vm._v("【部分正确】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    q.answerRecord.answerState == "Blank"
                                      ? _c("span", { staticClass: "wrong" }, [
                                          _vm._v("【未作答】")
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(q.num) +
                                        "、"
                                    ),
                                    _c("span", {
                                      attrs: { id: q.num },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.replaceNToBr(
                                            q.answerRecord.question
                                              .questionStemString
                                          )
                                        )
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  q.answerRecord.question.imageUrlList &&
                                  q.answerRecord.question.imageUrlList.length >
                                    0
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          q.answerRecord.question.imageUrlList,
                                          function(i) {
                                            return _c("img", {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px"
                                              },
                                              attrs: { src: i },
                                              on: {
                                                click: function($event) {
                                                  return _vm.clickImg($event)
                                                }
                                              }
                                            })
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  q.answerRecord.questionType == "SingleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          _vm._l(
                                            q.answerRecord.question.choices,
                                            function(value, k) {
                                              return _c(
                                                "p",
                                                [
                                                  _c(
                                                    "el-radio",
                                                    {
                                                      staticClass:
                                                        "my-disabled",
                                                      attrs: { label: k },
                                                      model: {
                                                        value:
                                                          q.answerRecord
                                                            .tjkAnswer,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            q.answerRecord,
                                                            "tjkAnswer",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "q.answerRecord.tjkAnswer"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(k) +
                                                          "、" +
                                                          _vm._s(value)
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "MultipleChoice"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                staticClass: "my-disabled",
                                                model: {
                                                  value:
                                                    q.answerRecord.tjkAnswer,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      q.answerRecord,
                                                      "tjkAnswer",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "q.answerRecord.tjkAnswer"
                                                }
                                              },
                                              _vm._l(
                                                q.answerRecord.question.choices,
                                                function(value, k) {
                                                  return _c(
                                                    "p",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        { attrs: { label: k } },
                                                        [
                                                          _vm._v(
                                                            _vm._s(k) +
                                                              "、" +
                                                              _vm._s(value)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : q.answerRecord.questionType ==
                                      "TrueOrFalse"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                staticClass: "my-disabled",
                                                model: {
                                                  value:
                                                    q.answerRecord.tjkAnswer,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      q.answerRecord,
                                                      "tjkAnswer",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "q.answerRecord.tjkAnswer"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: true }
                                                      },
                                                      [_vm._v("正确")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: { label: false }
                                                      },
                                                      [_vm._v("错误")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      })
                    ],
                    2
                  )
                ]
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("div", { staticClass: "count" }, [
          _c("h2", [_vm._v("统计")]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("span", { staticClass: "blue" }, [
              _vm._v(
                _vm._s(
                  _vm.examRecord.score >= _vm.exam.passScore ? "通过" : "未通过"
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v("得分：" + _vm._s(_vm.examRecord.score))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "useTime" }, [
            _c("p", { staticClass: "txt" }, [
              _vm._v("通过分数：" + _vm._s(_vm.exam.passScore))
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _vm._l(_vm.groupRecordList, function(l, QIndex) {
                return [
                  _vm._l(l.questionRecordFullList, function(q, qIndex) {
                    return [
                      _c(
                        "li",
                        {
                          class: {
                            active2: q.answerRecord.answerState == "Right",
                            active4: q.answerRecord.answerState != "Right"
                          }
                        },
                        [
                          _c("a", { attrs: { href: "#" + q.num } }, [
                            _vm._v(_vm._s(q.num))
                          ])
                        ]
                      )
                    ]
                  })
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn" }, [
            _c("div", { staticClass: "hold", on: { click: _vm.exitExam } }, [
              _vm._v("继续测试")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hold", on: { click: _vm.relearn } }, [
              _vm._v("重新学习")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showImg
        ? _c("zoom-img", {
            attrs: { imgSrc: _vm.imgSrc },
            on: { clickit: _vm.viewImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dce04a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dce04a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/basicExamDetail.vue
// module id = 1596
// module chunks = 0